import { createContext, useContext } from 'react';

import noop, { NoOp } from 'utils/noop';

import { EmailPreviewType, PreviewWithDataErrorMessage } from '../../common/types';

export interface EmailPreviewContextState {
  isLoading: boolean;
  messageContent: string;
  messageFromName: string;
  messagePreheader: string;
  messageSubject: string;
  onRefreshPreview: NoOp;
  previewError?: PreviewWithDataErrorMessage;
  selectedPreview: EmailPreviewType;
  setSelectedPreview: (preview: EmailPreviewType) => void;
}

export const EmailPreviewContext = createContext<EmailPreviewContextState>({
  isLoading: false,
  messageContent: '',
  messageFromName: '',
  messagePreheader: '',
  messageSubject: '',
  onRefreshPreview: noop,
  previewError: undefined,
  selectedPreview: EmailPreviewType.Desktop,
  setSelectedPreview: noop,
});

export const useEmailPreviewContext = () => useContext(EmailPreviewContext);
